<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          text
          tile
          class="text-subtitle-2"
          v-bind="attrs"
          data-cy="timer-button"
          v-on="on"
        >
          {{ tempoRestanteSessao }}
          <v-icon class="pl-2" :color="clockColor" data-cy="timer-button-icon"
            >mdi-timer-outline</v-icon
          >
        </v-btn>
      </template>

      <v-list dense data-cy="timer-list">
        <v-list-item link @click="refreshToken" data-cy="timer-list-item">
          <v-list-item-title data-cy="timer-list-item-title">
            <v-icon class="pr-2" color="primary" data-cy="timer-list-item-icon"
              >mdi-refresh-circle</v-icon
            >
            Renovar Sessão
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tempoRestanteSessao: '',
      tempo: 0,
      clockColor: 'green',
      user: null,
      msg: 'Deseja renovar a sessão?',
    }
  },
  methods: {
    startCountdown () {
      const th = this
      const isLogged = th.setExpirationTime()
      if (th.tempo > 0) {
        th.clockColor = 'green'
        let min = parseInt(th.tempo / 60)
        let seg = th.tempo % 60

        if (min < 10) {
          min = '0' + min
          min = min.substr(0, 2)
          if (min === 0) th.clockColor = 'amber'
          else th.clockColor = 'green'
        }
        if (seg <= 9) seg = '0' + seg

        th.tempoRestanteSessao = min + ':' + seg

        if (isLogged) {
          setTimeout(function () {
            th.startCountdown()
          }, 1000)
        }
      } else {
        th.clockColor = 'red'
        th.tempoRestanteSessao = '00:00'
        th.$api.UI.Confirmacao(
          'info',
          'Deseja renovar a sessão?',
          th.refreshToken,
          th.logout,
          'Sessão expirada'
        )
      }
    },
    setExpirationTime () {
      const status = localStorage.getItem('status')
      this.user = this.$store.getters.user
      if (status) {
        if (status === 'loggedIn') {
          while (!this.user) {
            this.user = JSON.parse(localStorage.getItem('user'))
          }

          const dataExpiracao = new Date(this.user.expiresAt)
          const dataAtual = new Date()
          this.tempo = Math.trunc(
            (dataExpiracao.getTime() - dataAtual.getTime()) / 1000
          )
        } else {
          this.$api.UTIL.Auth.Logout('confirma')
          return false
        }
      }
      return true
    },
    logout () {
      const th = this
      th.$api.Autenticacao.Logout()
        .then(function (data) {
          if (th.$api.UI.PostLoadData(data)) {
            th.$api.UTIL.Auth.Logout()
          }
        })
        .catch((err) => console.log(err))
    },
    refreshToken () {
      const th = this
      th.$api.Autenticacao.RefreshTokenOnboarding(th.user.refreshToken)
        .then(function (data) {
          data.roles = th.GetUserTokenRole(data.accessToken)
          const user = th.$api.UTIL.Auth.RegisterToken(
            data,
            th.user.identificador
          )
          if (user) {
            th.$store.dispatch('setUserData', { user })
            th.user = data

            if (th.tempo <= 0) {
              setTimeout(function () {
                th.startCountdown()
              }, 500)
            }

            const dataExpiracao = new Date(
              new Date().getTime() + data.expires * 60
            )
            const dataAtual = new Date()
            th.tempo = Math.trunc(
              (dataExpiracao.getTime() - dataAtual.getTime()) / 1000
            )
          } else {
            th.$api.UI.ShowError('Erro', 'Não foi possível renovar a sessão')
            setTimeout(th.logout(), 3000)
          }
        })
        .catch((err) => console.log(err))
    },
    getUserRole (jwtToken) {
      const jwtData = jwtToken.split('.')[1]
      const decodedJwtJsonData = window.atob(jwtData)
      return JSON.parse(decodedJwtJsonData).role
    },
    GetUserTokenRole (token) {
      try {
        var base64Url = token.split('.')[1]
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        var jsonPayload = decodeURIComponent(
          window
            .atob(base64)
            .split('')
            .map(function (c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            })
            .join('')
        )
        return JSON.parse(jsonPayload).client_role
      } catch {
        const jwtData = token.split('.')[1]
        const decodedJwtJsonData = window.atob(jwtData)
        return JSON.parse(decodedJwtJsonData).client_role
      }
    },
  },
  mounted: function () {
    this.setExpirationTime()
    if (this.tempo > 0) this.startCountdown()
  },
}
</script>
